import React from 'react'
import { ReactComponent as IconBreadcrumbHome } from '@/assets/svgs/breadcrumb-home.svg'
import { ReactComponent as IconBreadcrumbNext } from '@/assets/svgs/breadcrumb-next.svg'
import classname from 'classnames'

const Breadcrumbs = ({ items }) => {

	const totalItems = items.length

	const BreadcrumbsItems = items.map((item, index) => {

		const breadcrumbItemClass = classname({
			'breadcrumbs__item': true,
			'breadcrumbs__item--active': totalItems === index + 1
		})

		return (
			<React.Fragment key={index}>
				<div className="breadcrumbs__items__col">
					<div className={breadcrumbItemClass}>{item}</div>
				</div>
				{ totalItems > index + 1 && (
					<div className="breadcrumbs__items__col">
						<IconBreadcrumbNext data-testid="icon-breadcrumb-next"/>
					</div>
				)}
			</React.Fragment>
		)
	})

	return (
		<div className="breadcrumbs">
			<div className="breadcrumbs__home"><IconBreadcrumbHome data-testid="icon-breadcrumb-home"/></div>
			<div className="breadcrumbs__items">
				<div className="breadcrumbs__items__cols">
					{BreadcrumbsItems}
				</div>
			</div>
		</div>
	)
}

export default Breadcrumbs
